<template>
  <div>
    <van-dialog v-model="unpaidVisible" :showConfirmButton="false" close-on-click-overlay>
      <div class="fee-detail">
        <img class="state12_bg" src="@/assets/img/state12_bg.png" alt="" />
        <p class="fee-title">Sistem big data OJK memberi peringatan</p>
        <p class="fee-msg">
          {{ loanFailedMsg }}
        </p>
      </div>
      <div class="btn_list">
        <button v-for="(item, index) in unpaidProductList" :key="index" @click="goToProjectPage(item)">
          <span>{{ item }}</span>
        </button>
      </div>
      <button type="button" class="confirm-unpaidVisible" @click="closeDialog()">OKE</button>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component

  },
  data () {
    return {
    }
  },
  props: {
    unpaidVisible: {
      type: Boolean,
      default: true
    },
    unpaidProductList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    loanFailedMsg: {
      type: String,
      default: ''
    },
    closeDialog: {
      default: () => { }
    }
  },
  methods: {
    // 跳转到对应项目的落地页
    goToProjectPage (item) {
      const projectUrls = {
        Saku: 'http://ojk.pasarpinjaman.cc/sk1',
        'Cinta Uang': 'http://ojk.pasarpinjaman.cc/sk1',
        'Buku Dana': 'http://ojk.pasarpinjaman.cc/pi',
        'Uang Cepat': 'http://ojk.pasarpinjaman.cc/pi',
        'Dana Coin': 'http://ojk.pasarpinjaman.cc/dc',
        'Sangat Mudah': 'http://ojk.pasarpinjaman.cc/dc',
        'Aku Cepat': 'http://ojk.pasarpinjaman.cc/cl',
        'Pinjaman Bintang': 'http://ojk.pasarpinjaman.cc/cl',
        PowerS: 'http://ojk.pasarpinjaman.cc/pd',
        'Easy Dana': 'http://ojk.pasarpinjaman.cc/pd',
        BRD: 'http://ojk.pasarpinjaman.cc/brd',
        'Dana Roket': 'http://ojk.pasarpinjaman.cc/dr',
        'Modal Uang': 'http://ojk.pasarpinjaman.cc/mu',
        UangMu: 'http://ojk.pasarpinjaman.cc/um',
        'Uang Mu': 'http://ojk.pasarpinjaman.cc/um',
        'Dana Online': 'http://ojk.pasarpinjaman.cc/do',
        'Pinjaman Tunai': 'http://ojk.pasarpinjaman.cc/pt',
        KoinP2P: 'http://ojk.pasarpinjaman.cc/pt'

      }
      const url = projectUrls[item]
      window.location = url + '?tm=' + item
    }
  }
}
</script>

<style scoped lang="less">
.btn_list {
  padding: 30px;
  padding-top: 10px;
  display: grid;
  justify-content: space-around;
  grid-template-columns: repeat(auto-fill, 240px);

  // span {
  //   border-bottom: 1px solid blue;
  // }

  button {
    width: 240px;
    background: none;
    background: #b46cf8;
    color: #fff;
    font-size: 24px;
    border-radius: 10px;
    padding: 10px 15px;
    margin-bottom: 20px;
  }

}

.fee-detail {
  position: relative;
  padding: 20px 30px;
  margin: 0 auto;

  .state12_bg {
    width: 502px;
    height: 430px;
    position: absolute;
    top: -320px;
    left: 50%;
    transform: translateX(-50%);
  }

  &>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    padding-left: 24px;
    padding-right: 24px;

    p {
      font-size: 30px;
      font-weight: 400;
      color: #ffffff;
    }

    p:nth-child(even) {
      font-weight: 600;
    }
  }

  .interest {
    position: relative;
    padding-bottom: 60px;

    span:nth-child(1) {
      font-weight: 500;
      text-decoration: line-through;
      font-size: 26px;
      margin-right: 10px;
    }

    div {
      position: absolute;
      bottom: -28px;
    }
  }

  .describe {
    margin-bottom: -5px;
    font-size: 26px;
    color: #ff8300;
    line-height: 28px;
  }
}

.fee-title {
  text-align: center;
  font-size: 36px;
  color: #fff;
  margin-top: 120px;
  margin-bottom: 50px;
  font-weight: 600;
}

.fee-msg {
  font-size: 24px;
  color: #fff;
  margin-top: -30px;
}

.confirm-unpaidVisible {
  .submit-btn;
  width: 500px;
  margin-bottom: 50px;
}

/deep/ .van-dialog {
  top: 55%;
}
</style>
